unit View.Modulos_Data_Base.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewModulos_Data_BaseEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbmodulo_id: TLabel;
    edmodulo_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientModulos_Data_BaseGet: TXDataWebClient;
    XDataClientModulos_Data_BaseDelete: TXDataWebClient;
    Modulos_Data_BaseDataset: TXDataWebDataSet;
    Modulos_Data_BaseDatasetid: TIntegerField;
    Modulos_Data_BaseDatasetaliado_id: TIntegerField;
    Modulos_Data_BaseDatasetmodulo_id: TIntegerField;
    Modulos_Data_BaseDatasetdata_base_id: TIntegerField;
    Modulos_Data_BaseDatasetcodigo_interno: TIntegerField;
    Modulos_Data_BaseDatasetexcluido: TBooleanField;
    Modulos_Data_BaseDatasetinclusao: TDateTimeField;
    Modulos_Data_BaseDatasetalteracao: TDateTimeField;
    Modulos_Data_BaseDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientModulos_Data_BaseGetLoad(Response: TXDataClientResponse);
    procedure XDataClientModulos_Data_BaseDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientModulos_Data_BaseDeleteError(Error: TXDataClientError);
    procedure Modulos_Data_BaseDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewModulos_Data_BaseEdit: TFViewModulos_Data_BaseEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewModulos_Data_BaseEdit }

procedure TFViewModulos_Data_BaseEdit.btSaveClick(Sender: TObject);
begin
  if Modulos_Data_BaseDataset.State in dsEditModes then
  begin
        Modulos_Data_BaseDataset.Post;
    Modulos_Data_BaseDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewModulos_Data_BaseEdit.btDeleteClick(Sender: TObject);
begin
  if Modulos_Data_BaseDataset.State in dsEditModes then
    Modulos_Data_BaseDataset.Post;
  XDataClientModulos_Data_BaseDelete.Delete(Modulos_Data_BaseDataset.EntitySetName,
    TJSObject(Modulos_Data_BaseDataset.CurrentData));
end;


class function TFViewModulos_Data_BaseEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewModulos_Data_BaseEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewModulos_Data_BaseEdit.InsertEntity;
begin
  Modulos_Data_BaseDataset.Close;
  Modulos_Data_BaseDataset.SetJsonData('{}');
  Modulos_Data_BaseDataset.Open;
  Modulos_Data_BaseDataset.Insert;
end;

class function TFViewModulos_Data_BaseEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewModulos_Data_BaseEdit(AForm).FInserting := AInserting;
    TFViewModulos_Data_BaseEdit(AForm).FId := AId;
    TFViewModulos_Data_BaseEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewModulos_Data_BaseEdit(AForm).InsertEntity
    else
      TFViewModulos_Data_BaseEdit(AForm).LoadEntity;
    TFViewModulos_Data_BaseEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewModulos_Data_BaseEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewModulos_Data_BaseEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Modulos_Data_BaseDataset.Connection.Model.DefaultSchema.FindEntityType(
      Modulos_Data_BaseDataset.EntitySetName
    )
  );
  XDataClientModulos_Data_BaseGet.Get(Modulos_Data_BaseDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewModulos_Data_BaseEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewModulos_Data_BaseEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewModulos_Data_BaseEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewModulos_Data_BaseEdit.XDataClientModulos_Data_BaseGetLoad(Response: TXDataClientResponse);
begin
  Modulos_Data_BaseDataset.Close;
  Modulos_Data_BaseDataset.SetJsonData(Response.Result);
  Modulos_Data_BaseDataset.Open;
  
  Modulos_Data_BaseDataset.Edit;  
end;

procedure TFViewModulos_Data_BaseEdit.XDataClientModulos_Data_BaseDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewModulos_Data_BaseEdit.XDataClientModulos_Data_BaseDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewModulos_Data_BaseEdit.Modulos_Data_BaseDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewModulos_Data_BaseEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewModulos_Data_BaseEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.modulos_data_base.form.message');
  lbMessage := TLabel.Create('view.modulos_data_base.form.message.label');
  btCloseMessage := TButton.Create('view.modulos_data_base.form.message.button');
  btCancel := TButton.Create('view.modulos_data_base.form.btBack');
  btSave := TButton.Create('view.modulos_data_base.form.btSave');
  btDelete := TButton.Create('view.modulos_data_base.form.btDelete');
  lbid := TLabel.Create('view.modulos_data_base.form.lbid');
  edid := TDBEdit.Create('view.modulos_data_base.form.edid');
  lbaliado_id := TLabel.Create('view.modulos_data_base.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.modulos_data_base.form.edaliado_id');
  lbmodulo_id := TLabel.Create('view.modulos_data_base.form.lbmodulo_id');
  edmodulo_id := TDBEdit.Create('view.modulos_data_base.form.edmodulo_id');
  lbdata_base_id := TLabel.Create('view.modulos_data_base.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.modulos_data_base.form.eddata_base_id');
  lbcodigo_interno := TLabel.Create('view.modulos_data_base.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.modulos_data_base.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.modulos_data_base.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.modulos_data_base.form.edexcluido');
  lbinclusao := TLabel.Create('view.modulos_data_base.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.modulos_data_base.form.edinclusao');
  lbalteracao := TLabel.Create('view.modulos_data_base.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.modulos_data_base.form.edalteracao');
  lbexclusao := TLabel.Create('view.modulos_data_base.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.modulos_data_base.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Modulos_Data_BaseDataset := TXDataWebDataSet.Create(Self);
  Modulos_Data_BaseDatasetid := TIntegerField.Create(Self);
  Modulos_Data_BaseDatasetaliado_id := TIntegerField.Create(Self);
  Modulos_Data_BaseDatasetmodulo_id := TIntegerField.Create(Self);
  Modulos_Data_BaseDatasetdata_base_id := TIntegerField.Create(Self);
  Modulos_Data_BaseDatasetcodigo_interno := TIntegerField.Create(Self);
  Modulos_Data_BaseDatasetexcluido := TBooleanField.Create(Self);
  Modulos_Data_BaseDatasetinclusao := TDateTimeField.Create(Self);
  Modulos_Data_BaseDatasetalteracao := TDateTimeField.Create(Self);
  Modulos_Data_BaseDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientModulos_Data_BaseGet := TXDataWebClient.Create(Self);
  XDataClientModulos_Data_BaseDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbmodulo_id.BeforeLoadDFMValues;
  edmodulo_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Modulos_Data_BaseDataset.BeforeLoadDFMValues;
  Modulos_Data_BaseDatasetid.BeforeLoadDFMValues;
  Modulos_Data_BaseDatasetaliado_id.BeforeLoadDFMValues;
  Modulos_Data_BaseDatasetmodulo_id.BeforeLoadDFMValues;
  Modulos_Data_BaseDatasetdata_base_id.BeforeLoadDFMValues;
  Modulos_Data_BaseDatasetcodigo_interno.BeforeLoadDFMValues;
  Modulos_Data_BaseDatasetexcluido.BeforeLoadDFMValues;
  Modulos_Data_BaseDatasetinclusao.BeforeLoadDFMValues;
  Modulos_Data_BaseDatasetalteracao.BeforeLoadDFMValues;
  Modulos_Data_BaseDatasetexclusao.BeforeLoadDFMValues;
  XDataClientModulos_Data_BaseGet.BeforeLoadDFMValues;
  XDataClientModulos_Data_BaseDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewModulos_Data_BaseEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 508;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 448;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 448;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 448;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbmodulo_id.SetParentComponent(Self);
    lbmodulo_id.Name := 'lbmodulo_id';
    lbmodulo_id.Left := 24;
    lbmodulo_id.Top := 246;
    lbmodulo_id.Width := 14;
    lbmodulo_id.Height := 13;
    lbmodulo_id.Caption := 'modulo_id:';
    lbmodulo_id.Transparent := True;
    edmodulo_id.SetParentComponent(Self);
    edmodulo_id.Name := 'edmodulo_id';
    edmodulo_id.Left := 221;
    edmodulo_id.Top := 243;
    edmodulo_id.Width := 200;
    edmodulo_id.Height := 21;
    edmodulo_id.Enabled := True;
    edmodulo_id.TabOrder := 8;
    edmodulo_id.Text := 'edmodulo_id';
    edmodulo_id.DataField := 'modulo_id';
    edmodulo_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 273;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 270;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 9;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 300;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 297;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 10;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 327;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 324;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 11;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 354;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 351;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 12;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 381;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 378;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 13;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 408;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 405;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 14;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Modulos_Data_BaseDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Modulos_Data_BaseDataset.SetParentComponent(Self);
    Modulos_Data_BaseDataset.Name := 'Modulos_Data_BaseDataset';
    Modulos_Data_BaseDataset.AfterApplyUpdates := Modulos_Data_BaseDatasetAfterApplyUpdates;
    Modulos_Data_BaseDataset.EntitySetName := 'Modulos_Data_Base';
    Modulos_Data_BaseDataset.Connection := DMConnection.ApiConnection;
    Modulos_Data_BaseDataset.Left := 176;
    Modulos_Data_BaseDataset.Top := 8;
    Modulos_Data_BaseDatasetid.SetParentComponent(Modulos_Data_BaseDataset);
    Modulos_Data_BaseDatasetid.Name := 'Modulos_Data_BaseDatasetid';
    Modulos_Data_BaseDatasetid.FieldName := 'id';
    Modulos_Data_BaseDatasetid.Required := True;
    Modulos_Data_BaseDatasetaliado_id.SetParentComponent(Modulos_Data_BaseDataset);
    Modulos_Data_BaseDatasetaliado_id.Name := 'Modulos_Data_BaseDatasetaliado_id';
    Modulos_Data_BaseDatasetaliado_id.FieldName := 'aliado_id';
    Modulos_Data_BaseDatasetaliado_id.Required := True;
    Modulos_Data_BaseDatasetmodulo_id.SetParentComponent(Modulos_Data_BaseDataset);
    Modulos_Data_BaseDatasetmodulo_id.Name := 'Modulos_Data_BaseDatasetmodulo_id';
    Modulos_Data_BaseDatasetmodulo_id.FieldName := 'modulo_id';
    Modulos_Data_BaseDatasetmodulo_id.Required := True;
    Modulos_Data_BaseDatasetdata_base_id.SetParentComponent(Modulos_Data_BaseDataset);
    Modulos_Data_BaseDatasetdata_base_id.Name := 'Modulos_Data_BaseDatasetdata_base_id';
    Modulos_Data_BaseDatasetdata_base_id.FieldName := 'data_base_id';
    Modulos_Data_BaseDatasetdata_base_id.Required := True;
    Modulos_Data_BaseDatasetcodigo_interno.SetParentComponent(Modulos_Data_BaseDataset);
    Modulos_Data_BaseDatasetcodigo_interno.Name := 'Modulos_Data_BaseDatasetcodigo_interno';
    Modulos_Data_BaseDatasetcodigo_interno.FieldName := 'codigo_interno';
    Modulos_Data_BaseDatasetcodigo_interno.Required := True;
    Modulos_Data_BaseDatasetexcluido.SetParentComponent(Modulos_Data_BaseDataset);
    Modulos_Data_BaseDatasetexcluido.Name := 'Modulos_Data_BaseDatasetexcluido';
    Modulos_Data_BaseDatasetexcluido.FieldName := 'excluido';
    Modulos_Data_BaseDatasetexcluido.Required := False;
    Modulos_Data_BaseDatasetinclusao.SetParentComponent(Modulos_Data_BaseDataset);
    Modulos_Data_BaseDatasetinclusao.Name := 'Modulos_Data_BaseDatasetinclusao';
    Modulos_Data_BaseDatasetinclusao.FieldName := 'inclusao';
    Modulos_Data_BaseDatasetinclusao.Required := False;
    Modulos_Data_BaseDatasetalteracao.SetParentComponent(Modulos_Data_BaseDataset);
    Modulos_Data_BaseDatasetalteracao.Name := 'Modulos_Data_BaseDatasetalteracao';
    Modulos_Data_BaseDatasetalteracao.FieldName := 'alteracao';
    Modulos_Data_BaseDatasetalteracao.Required := False;
    Modulos_Data_BaseDatasetexclusao.SetParentComponent(Modulos_Data_BaseDataset);
    Modulos_Data_BaseDatasetexclusao.Name := 'Modulos_Data_BaseDatasetexclusao';
    Modulos_Data_BaseDatasetexclusao.FieldName := 'exclusao';
    Modulos_Data_BaseDatasetexclusao.Required := False;
    XDataClientModulos_Data_BaseGet.SetParentComponent(Self);
    XDataClientModulos_Data_BaseGet.Name := 'XDataClientModulos_Data_BaseGet';
    XDataClientModulos_Data_BaseGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientModulos_Data_BaseGet, Self, 'OnLoad', 'XDataClientModulos_Data_BaseGetLoad');
    XDataClientModulos_Data_BaseGet.Left := 64;
    XDataClientModulos_Data_BaseGet.Top := 8;
    XDataClientModulos_Data_BaseDelete.SetParentComponent(Self);
    XDataClientModulos_Data_BaseDelete.Name := 'XDataClientModulos_Data_BaseDelete';
    XDataClientModulos_Data_BaseDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientModulos_Data_BaseDelete, Self, 'OnLoad', 'XDataClientModulos_Data_BaseDeleteLoad');
    SetEvent(XDataClientModulos_Data_BaseDelete, Self, 'OnError', 'XDataClientModulos_Data_BaseDeleteError');
    XDataClientModulos_Data_BaseDelete.Left := 64;
    XDataClientModulos_Data_BaseDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbmodulo_id.AfterLoadDFMValues;
    edmodulo_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Modulos_Data_BaseDataset.AfterLoadDFMValues;
    Modulos_Data_BaseDatasetid.AfterLoadDFMValues;
    Modulos_Data_BaseDatasetaliado_id.AfterLoadDFMValues;
    Modulos_Data_BaseDatasetmodulo_id.AfterLoadDFMValues;
    Modulos_Data_BaseDatasetdata_base_id.AfterLoadDFMValues;
    Modulos_Data_BaseDatasetcodigo_interno.AfterLoadDFMValues;
    Modulos_Data_BaseDatasetexcluido.AfterLoadDFMValues;
    Modulos_Data_BaseDatasetinclusao.AfterLoadDFMValues;
    Modulos_Data_BaseDatasetalteracao.AfterLoadDFMValues;
    Modulos_Data_BaseDatasetexclusao.AfterLoadDFMValues;
    XDataClientModulos_Data_BaseGet.AfterLoadDFMValues;
    XDataClientModulos_Data_BaseDelete.AfterLoadDFMValues;
  end;
end;

end.
